import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconYoutube = (props: IconProps) => (
  <svg
    className={iconStyles(props)}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 37 37"
  >
    <defs>
      <polygon id="group-a" points="0 0 36.463 0 36.463 36.463 0 36.463" />
    </defs>
    <g fill="none" fillRule="evenodd" opacity=".5">
      <path
        fill="#FFF"
        d="M15.8431 21.8162c2.085-1.197 4.153-2.386 6.241-3.585-2.09-1.206-4.157-2.398-6.241-3.601v7.186z"
      />
      <path
        fill="#FFF"
        d="M30.5002502 22.2221175c-.050735.7255101-.1369845 1.4520349-.3419538 2.1521775-.3663064 1.2480803-1.2115511 1.9928697-2.4870283 2.2049419-.7113043.1187198-1.4357996.1765577-2.1572509.2272926-2.3216323.1633666-4.6483381.1846753-7.3636738.205984-.938597-.0162352-2.2648091-.0314557-3.5900066-.0659554-.9274353-.0243528-1.8538558-.0659555-2.7792617-.1207493-.8685827-.0517497-1.7412242-.0933523-2.59154237-.2831011-1.32621215-.297307-2.1308688-1.1354487-2.43121983-2.4555726-.1694548-.7458041-.24149846-1.5068287-.30136573-2.268868-.09842584-1.2663449-.16032251-2.5347191-.12480803-3.8041081.03044098-1.0897872.09030825-2.1785597.16336661-3.2653028.04566147-.6930397.12277863-1.3870941.31354212-2.0578104.3571742-1.249095 1.18111014-2.0253401 2.45963142-2.2820591.81784771-.1633666 1.65193071-.2151162 2.48499891-.2516454 1.2348892-.0547938 2.4697784-.1177051 3.706697-.1390138 1.6184456-.02942632 3.2379059-.04058801 4.8563515-.02130872 1.4520349.01724992 2.9040697.07407302 4.3540752.14002852.8117596.0375439 1.6214897.1177051 2.4302052.1978664.5225702.0527644 1.0410816.1410432 1.5149462.3886299.8594504.4505265 1.3810059 1.1608161 1.5981516 2.1024572.1613372.7042014.2506308 1.4175351.3115127 2.1339129.1126317 1.3373738.1785871 2.6788065.1410433 4.0222685-.030441 1.0806549-.091323 2.1623245-.1664107 3.2399353M18.4994.0002c-10.21700856 0-18.5 8.28299144-18.5 18.4989853 0 10.2170086 8.28299144 18.5 18.5 18.5 10.2170086 0 18.5-8.2829914 18.5-18.5C36.9994 8.28319144 28.7164086.0002 18.4994.0002"
        mask="url(#group-b)"
      />
    </g>
  </svg>
);
